import { FC } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import ConversationsSettingsHandler from './ConversationsSettingsHandler';
import UserManagementHandler from '../UserManagement/UserManagementHandler';
import SurveyList from '../Survey/SurveyList';
import SurveyForm from '../Survey/SurveyForm';
import SurveyViewPage from '../Survey/SurveyViewPage';
import { useRootState } from '../../store/hooks';
import { SettingsSurveysRoute } from '../../Routes';
import '../../styles/skeletons.css';

const UnifiedSettingsContainer: FC = () => {
    const location = useLocation();
    const params = useParams();
    const navigate = useNavigate();
    const { state } = useRootState();
    const appLoading = state.appLoading ?? false;
    const conversationsLoading = state.conversationsLoading ?? false;
    const loading = appLoading || conversationsLoading;
    
    if (loading) {
        return (
            <div className="settings-skeleton-container">
                <div className="react-loading-skeleton settings-skeleton-card h-460" />
            </div>
        );
    }

    const path = location.pathname;

    // Determine which component to render based on the URL
    // Order matters: check more specific routes first
    if (path === '/settings/surveys/new') {
        return <SurveyForm surveyId={undefined} onClose={() => navigate(SettingsSurveysRoute)} />;
    } else if (path.startsWith('/settings/surveys/edit')) {
        const surveyId = params.id;
        return <SurveyForm surveyId={surveyId} onClose={() => navigate(SettingsSurveysRoute)} />;
    } else if (path.startsWith('/settings/surveys/view')) {
        const surveyId = params.id;
        if (!surveyId) {
            navigate(SettingsSurveysRoute);
            return null;
        }
        return <SurveyViewPage surveyId={surveyId} onClose={() => navigate(SettingsSurveysRoute)} />;
    } else if (path.startsWith('/settings/surveys')) {
        return <SurveyList />;
    } else if (path === '/settings/user-management') {
        return <UserManagementHandler />;
    } else if (path === '/settings/chats') {
        return <ConversationsSettingsHandler />;
    } else {
        // Default fallback
        return <ConversationsSettingsHandler />;
    }
};

export default UnifiedSettingsContainer;
